// eslint-disable-next-line no-unused-vars
import styles from "../../../../styles/selectBar.css";

const WorksheetSelectBar = ({ typeSelect, setTypeSelect }) => {
  return (
    <select
      id="typeSelect"
      value={typeSelect}
      onChange={(e) => setTypeSelect(e.target.value)}
      style={{
        height: "42px",
        padding: "0 16px",
        fontSize: "0.9rem",
        fontWeight: 600,
        fontFamily: "inherit",
        color: "#3A434E",
        width: "180px",
        border: "1.5px solid #E6EDEC",
        borderRadius: "999px",
        cursor: "pointer",
        backgroundColor: "#F4F8F7",
        outline: "none",
      }}
      className="customSelect"
    >
      <option value="all">학습지 종류 전체</option>
      <option value="analysis">지문분석 워크북</option>
      <option value="comprehensive">내용이해 워크북</option>
      <option value="paragraph">모의고사 유형</option>
      <option value="vocabulary">단어</option>
      <option value="sentence">문장</option>
      <option value="grammar">어법</option>
      <option value="paper">지필과제</option>
      <option value="leveltest">레벨테스트</option>
    </select>
  );
};

export default WorksheetSelectBar;
